import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/app/caminhao/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/caminhao/novo" });
  }
});
